import { useEffect, useState } from 'react';

type Props = {
  pageName: string;
  properties?: Record<string, unknown>;
  skip?: boolean;
};

export const usePageView = ({ pageName, properties, skip = false }: Props) => {
  const [viewed, setViewed] = useState(false);
  const analyticsLoaded = typeof window !== 'undefined' && !!window?.analytics;

  useEffect(() => {
    if (!viewed && !skip) {
      if (process.env.GATSBY_ENVIRONMENT === 'production' && analyticsLoaded) {
        setViewed(true);
        window.analytics.page(pageName, {
          windowWidth: `${window.innerWidth}`,
          windowHeight: `${window.innerHeight}`,
          ...properties,
        });
      }
    }
  }, [viewed, setViewed, analyticsLoaded, skip]);
};
